import { useEffect, useLayoutEffect, useState, type ReactNode } from "react";
import { useUiStore } from "@/lib/store/ui-store";
import {
  persistSurfaceMode,
  readStoredSurfaceMode,
} from "@/lib/catalog-pending/responsive/surfaceMode";

function currentStoredSurfaceMode(): ReturnType<typeof readStoredSurfaceMode> {
  try {
    if (typeof localStorage === "undefined") return "auto";
    return readStoredSurfaceMode(localStorage);
  } catch {
    return "auto";
  }
}

function persistMode(mode: ReturnType<typeof currentStoredSurfaceMode>): void {
  if (typeof localStorage === "undefined") return;
  persistSurfaceMode(localStorage, mode);
}

export function SurfaceModeProvider({
  children,
}: {
  readonly children: ReactNode;
}): React.JSX.Element {
  const mode = useUiStore((s) => s.surfaceMode);
  const setSurfaceMode = useUiStore((s) => s.setSurfaceMode);
  const [hydrated, setHydrated] = useState(false);

  useLayoutEffect(() => {
    setSurfaceMode(currentStoredSurfaceMode());
    setHydrated(true);
  }, [setSurfaceMode]);

  useEffect(() => {
    if (!hydrated) return;
    persistMode(mode);
  }, [hydrated, mode]);

  return <>{children}</>;
}
